import { render, staticRenderFns } from "./BoardTotal.vue?vue&type=template&id=f29c1466&scoped=true"
import script from "./BoardTotal.vue?vue&type=script&lang=js"
export * from "./BoardTotal.vue?vue&type=script&lang=js"
import style0 from "./BoardTotal.vue?vue&type=style&index=0&id=f29c1466&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29c1466",
  null
  
)

export default component.exports